module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "classify"
  }, [_c('mt-header', {
    attrs: {
      "fixed": "",
      "title": "全部产品分类"
    }
  }, [_c('mt-button', {
    attrs: {
      "icon": "back"
    },
    on: {
      "click": _vm.goBack
    },
    slot: "left"
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('mt-search', {
    attrs: {
      "cancel-text": "取消",
      "placeholder": "搜索您想要的产品"
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.lists), function(list) {
    return _c('section', {
      staticClass: "tea"
    }, [_c('h3', [_vm._v(_vm._s(list.title))]), _vm._v(" "), _c('div', [_c('ul', [_vm._l((list.items), function(item) {
      return _c('li', [_c('router-link', {
        attrs: {
          "to": ""
        }
      }, [_c('p', [_c('img', {
        attrs: {
          "src": item.img
        }
      })]), _vm._v(" "), _c('p', {
        staticClass: "text"
      }, [_vm._v(_vm._s(item.text))])])], 1)
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })], 2)])])
  }), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('NavBar')], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43c37aa0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/classify.vue
// module id = 222
// module chunks = 1